import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200 mt-auto">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                年轻的母亲<span className="text-accent-600">3</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
              本站为《年轻的母亲3》剧集资料与资讯展示平台，提供全集剧情介绍、角色分析与最新动态，
              帮助影视剧爱好者全面了解这部作品。站内内容均为整理与演示用途。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:contact@youngmother3.example.com"
                aria-label="邮箱"
                className="w-9 h-9 rounded-md bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-700 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a href="#" aria-label="微博" className="w-9 h-9 rounded-md bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-700 hover:border-primary-300 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" aria-label="哔哩哔哩" className="w-9 h-9 rounded-md bg-background-50 border border-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-700 hover:border-primary-300 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <nav aria-label="底部导航">
            <h4 className="font-heading font-bold text-sm text-foreground-950 mb-4">站内导航</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/plot" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">剧情介绍</Link></li>
              <li><Link to="/category/character" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">角色分析</Link></li>
              <li><Link to="/category/news" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">最新资讯</Link></li>
              <li><Link to="/search" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">搜索</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">关于与联系</Link></li>
            </ul>
          </nav>

          <div>
            <h4 className="font-heading font-bold text-sm text-foreground-950 mb-4">联系方式</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-foreground-500"></i></span>
                contact@youngmother3.example.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line text-foreground-500"></i></span>
                内容整理 · 线上协作
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-time-line text-foreground-500"></i></span>
                每日 09:00 - 21:00 更新
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 年轻的母亲3 · 影视资料站. 本站为演示性质的剧集资料展示平台。</p>
          <p>剧情与角色内容均为虚构整理，仅供学习交流使用。</p>
        </div>
      </div>
    </footer>
  );
}